import { render, staticRenderFns } from "./artInfo.vue?vue&type=template&id=1f7b6518&scoped=true&"
import script from "./artInfo.vue?vue&type=script&lang=js&"
export * from "./artInfo.vue?vue&type=script&lang=js&"
import style0 from "./artInfo.vue?vue&type=style&index=0&id=1f7b6518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7b6518",
  null
  
)

export default component.exports